module.exports = __webpack_public_path__ + "img/jin10.b2346f4e.png";